import { Dispatch, useContext } from 'react'

import { DispatchContext, SearchMapContextInitialState, SearchMapContextStore } from '.'

export function useSearchMapContext(): [
  SearchMapContextInitialState,
  Dispatch<{
    type: string
  }>,
] {
  const ctx = useContext(SearchMapContextStore)
  const dispatch = useContext(DispatchContext)
  return [ctx, dispatch]
}
